import { TimeLogApi, ToastStateHandler } from '../../../api';
import { SubmitTimelogByOwnerDto } from '../../../commonTypes/timelog.types';
import { dispatch } from '../../../store';
import {
    invalidateActivityFeedCache,
    invalidateActivityLogsCache,
    invalidateProjectMetrics,
    invalidateSingleProjectCache,
    invalidateTimesheetCache,
} from '../../../store/slices/projects.slice';
import { addSubmissionIntervalOfProject } from '../../../store/slices/time-tracking.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

const useHttpSubmitTimelogs = () => {
    const { t } = useTranslation('newNotifications');
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (body: SubmitTimelogByOwnerDto, onSuccessCallback?: () => void) => {
        const { exec, abort } = timeLogApi.submitTimelogByOwner({
            body,
            onSuccess: res => {
                const projectId = res.body.projectId;
                dispatch(invalidateSingleProjectCache(projectId));
                dispatch(invalidateProjectMetrics(projectId));
                dispatch(invalidateTimesheetCache(projectId));
                dispatch(invalidateActivityLogsCache(projectId));
                dispatch(invalidateActivityFeedCache(projectId));
                dispatch(addSubmissionIntervalOfProject(res.body));
                toastHandler.push('success', t('timelog.timesheetSubmissionTitle'), t('timelog.timesheetSubmissionSuccess'));
                if (onSuccessCallback) {
                    onSuccessCallback();
                }
            },
            onError: (error: AppError | string) => {
                if (isErrorCode(error, ErrorCodes.OVERLAPPING_INTERVALS)) {
                    return toastHandler.push('warn', t('timelog.ownerSubmissionTitle'), t('timelog.ownerSubmissionWarnOverlapingIntervals'));
                }
                if (isErrorCode(error, ErrorCodes.NO_TIME_LOGS_TO_SUBMIT)) {
                    return toastHandler.push('warn', t('timelog.ownerSubmissionTitle'), t('timelog.ownerSubmissionWarnNoTimeLogsInInterval'));
                }
                // Use backend userMessage for unknown errors
                const message = getUserMessage(error);
                toastHandler.push('warn', t('timelog.ownerSubmissionTitle'), message);
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpSubmitTimelogs;
